module.exports = __webpack_public_path__ + "static/media/home-bg.bd079795.svg";